import { render, staticRenderFns } from "./NettoBiddingCheckoutSummary.vue?vue&type=template&id=0080af24&scoped=true"
import script from "./NettoBiddingCheckoutSummary.vue?vue&type=script&lang=js"
export * from "./NettoBiddingCheckoutSummary.vue?vue&type=script&lang=js"
import style0 from "./NettoBiddingCheckoutSummary.vue?vue&type=style&index=0&id=0080af24&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0080af24",
  null
  
)

export default component.exports